<div class="se-tool-upload-dicom_main-container themed-class" [ngClass]="{'scroll-incoming': originPage === 'incomingDicom'}">
    <div *ngIf="(uploaderService.showSpinner$ | async) || showSpinner" class="estensa-spinner">
        <mat-spinner></mat-spinner>
    </div>
    <div class="row align-fl-start">
        <div class="form-container">
            <patient-details-form (patientChanges)="onPatientFormChange($event)"
                                  *ngIf="showPatientForm"
                                  [isVNA]="isVNA"
                                  [patientInfo]="patientInfo">
            </patient-details-form>
        </div>
        <div class="drop-container">
            <import-file (fileData)="onFileUploaded($event)"
                         [acceptedTypeFile]="acceptedTypeFile"
                         class="drop-col">
            </import-file>
            <import-file (fileData)="loadDicomFiles($event)"
                         *ngIf="_acceptFolder"
                         [acceptFolder]="_acceptFolder"
                         [acceptedTypeFile]="acceptedTypeFile"
                         class="drop-col">
            </import-file>
        </div>
    </div>

    <div *ngIf="_data.length > 0" class="tab-container">
        <div class="table-head">
            <div class="row">
                <div class="col-action">
                    <mat-checkbox (ngModelChange)="toggleAll()"
                                  [indeterminate]="indeterminate"
                                  [ngModel]="checkAll">
                    </mat-checkbox>
                </div>
                <div class="col-action-delete"></div>
                <div class="col-feedback"></div>
                <div class="col-pid">{{'Pid' | translate}}</div>
                <div class="col-patient">{{'Patient' | translate}}</div>
                <div class="col-description">{{'Description' | translate}}</div>
                <div class="col-acc-number">{{'Accession_Number' | translate}}</div>
                <div class="col-date">{{'Date' | translate}}</div>
                <div class="col-modality">{{'Modality' | translate}}</div>
            </div>
        </div>

        <div *ngFor="let study of _data" class="patient-container mt-2">
            <study (checked)="onChecked(study.data.id, $event)"
                   (delete)="onRemoveStudy(study.data.id)"
                   [check]="childrenEvent$.get(study.data.id)!"
                   [patientToMatch]="patientInfo"
                   [sending]="sendingInstances.get(study.data.id)"
                   [study]="study"></study>
        </div>

        <div class="btn-container">
            <button (click)="_uploadAll()" [disabled]="disableImportAfterAllSent() || disableUploadButton || !this.patientFormValid" class="btn btn-primary btn-s"
                    type="button">
                <span class="glyphicon glyphicon-upload"></span> {{ 'Import' | translate }}
            </button>
        </div>

    </div>
    <div #dicomPopupWarning *ngIf="_showWarning" class="se-dicom-popup-panel">
        <message-dialog (onClickDialog)="_onWarningDialogClick($event)"
                        [messageBoxText]="messageBoxText">
        </message-dialog>
    </div>
</div>


